import React from 'react';
import MultiSelect from 'react-multi-select-component';
import './index.scss';

const MultiSelectDropdown = props => {
  const {
    value,
    options,
    onChange,
    disableSearch,
    disabled,
    isTableCell,
  } = props;

  const renderItems = ({
    checked,
    option,
    onClick,
    // disabled,
  }) => (
    <div className={`react-multi-select-custom-option ${checked && 'checked'}`} onClick={onClick}>
      <div className={''}>{option.label}</div>
    </div>
  );
  
  return (
    <MultiSelect
      className={`${disabled && 'disabled'} w-100 ${isTableCell && 'table-cell'}`}
      disabled={disabled}
      disableSearch={disableSearch}
      value={value}
      options={options}
      onChange={onChange}
      labelledBy={'Select'}
      ItemRenderer={renderItems}
    />
  );
};

export default MultiSelectDropdown;